window.addEventListener('DOMContentLoaded', function (e) {
	const calendarTab = document.querySelector('.calendar-tab')
	if (calendarTab) {
		const calendarTabMenu = calendarTab.querySelector('.calendar-tab-menu')
		if (calendarTabMenu) {
			calendarTabMenu.addEventListener('click', () => {
				calendarTab.classList.toggle('active')
			})
		}
		window.addEventListener('click', function (e) {
			if (
				!e.target.closest('.calendar-tab') &&
				!e.target.closest('.calendar-tab-menu')
			) {
				calendarTab.classList.remove('active')
			}
		})
	}
})
